import { Link } from "@tanstack/react-router";
import { LogoMark } from "@/components/site/logo";

export function SiteFooter() {
  return (
    <footer className="cv-auto mt-20 border-t border-border bg-navy text-primary-foreground">
      <div className="sky-bar h-1 w-full" />
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-14 lg:grid-cols-4 lg:px-8">
        <div>
          <div className="flex items-center gap-2.5">
            <LogoMark className="h-10 w-10" />
            <span className="font-display text-xl font-bold tracking-tight">
              Argentinian<span className="text-sky">.Soccer</span>
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-primary-foreground/70">
            Argentina's football daily — National Team, Primera División, transfers, and the diaspora abroad.
          </p>
          <p className="mt-3 font-condensed text-xs uppercase tracking-widest text-sky">
            argentinian.soccer
          </p>
        </div>
        <FooterCol title="Sections" links={[
          { to: "/news", label: "Latest News" },
          { to: "/national-team", label: "National Team" },
          { to: "/primera-division", label: "Primera División" },
          { to: "/forum", label: "Forum" },
          { to: "/forum/polls", label: "Polls" },
        ]} />
        <FooterCol title="Shop & Company" links={[
          { to: "/shop", label: "Shop" },
          { to: "/about-us", label: "About Us" },
          { to: "/contact-us", label: "Contact Us" },
          { to: "/contact-us/jobs", label: "Job Listings" },
        ]} />
        <FooterCol title="Account" links={[
          { to: "/log-in", label: "Log in" },
          { to: "/contact-us/partnership", label: "Become a partner" },
        ]} />
      </div>
      <div className="border-t border-white/10 py-4 text-center font-condensed text-xs uppercase tracking-widest text-primary-foreground/60">
        © {new Date().getFullYear()} Argentinian.Soccer · Independent fan media
      </div>
    </footer>
  );
}

function FooterCol({ title, links }: { title: string; links: { to: string; label: string }[] }) {
  return (
    <div>
      <h3 className="font-condensed text-sm font-bold uppercase tracking-widest text-sky">{title}</h3>
      <ul className="mt-4 space-y-1 text-sm">
        {links.map((l) => (
          <li key={l.to}>
            <Link to={l.to as "/"} className="-mx-2 block rounded px-2 py-2 text-primary-foreground/85 hover:bg-white/5 hover:text-sky">
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
